import styled from 'styled-components'

const BREAKPOINT = 1259

export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;

  padding-right: 1rem;
  border-right: 1px solid ${props => props.theme.colors.colorDCE3ED};

  @media screen and (max-width: ${BREAKPOINT}px) {
    padding: 1rem 1rem 1rem 0;
  }
`

export const Label = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: ${props => props.theme.colors.color2d3139};
`

export const Divisor = styled.div`
  position: relative;
  height: 59px;
  width: 1px;
  background: ${props => props.theme.colors.colorDCE3ED};

  @media screen and (max-width: ${BREAKPOINT}px) {
    display: none;
  }
`
